import BranchSwitcher from 'app/branches/components/branch-switcher';
import Link, { ProjectLink } from 'app/common/components/link';
import Help from 'app/help/components/help';
import UniversalSearch from 'app/universal-search/components/search';
import type React from 'react';
import BranchMerge from '../../branches/components/branch-merge';
import ProjectUsers from '../../collab/components/project-users';
import { TakeshapeLogoForHeader } from '../../common/components/logo/takeshape-logo-for-header';
import ProjectMenu from './project-menu';
import ProjectToolbar from './project-toolbar';
import type { TopbarHookProps } from './topbar-hook';
import UserMenu from './user-menu';

export type TopbarProps = TopbarHookProps;

/** The `Topbar` provides global navigation of the Takeshape application for users.
 *  It sticks to the top of the viewport during scrolling.
 */
const Topbar: React.FC<TopbarProps> = (props) => {
  const { projectId, branch, userRequiresEmailValidation } = props;

  let content: React.ReactNode;
  if (userRequiresEmailValidation) {
    content = (
      <div className="text-right w-full">
        <Link href="/logout">Log out</Link>
      </div>
    );
  } else {
    content = (
      <>
        <ProjectLink href="/projects">
          <TakeshapeLogoForHeader className="h-7 max-w-11" />
        </ProjectLink>
        <div data-testid="topbar-project-section" className="flex items-center bg-gray-100 h-8 rounded-md">
          <ProjectMenu />
          {projectId && branch && (
            <>
              <BranchSwitcher />
              <BranchMerge />
            </>
          )}
        </div>
        <div>
          <ProjectToolbar />
        </div>
        <div className="grow-1 flex items-center gap-2 justify-end">
          <UniversalSearch />
          <ProjectUsers />
          <UserMenu />
          <Help />
        </div>
      </>
    );
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-[1000] bg-base-100 h-12 px-4 flex gap-2 items-center border-b border-gray-200">
      {content}
    </div>
  );
};

export default Topbar;
